export const actionURLBase = 'https://www.diyinbound.com/producto/'

export const actionTypes = {
  en: {
    recurrent: `
    <p>Actions can be <strong>Punctual</strong> o <strong>Recurring</strong>.</p>

    <h4>Punctual Action</h4>
    
    <p>
      It is a type of action that has a beginning and an end: you activate them, they are executed,
      We document and terminate them. Then they got archived in case you want to consult
      your documentation in the future. Often times, it makes sense to hire specific actions
      more than once, for example: create different landing pages or create different buyer
      person.
    </p>

    <h4>Recurring Action</h4>

    <p>
      It is a type of action that has a beginning, but does not necessarily have an end, although
      you can deactivate it whenever you want.

      These are usually necessary actions for the day of a project, for example: the search for
      monthly keywords to be able to generate new content (inbound SEO action), or,
      an analytical action, in which a project area is analyzed on a monthly basis and
      actions are proposed for the following month.
    </p>
    `,

    technical: `
    <p>Actions can be <strong>We do it for you</strong> or <strong>Guided</strong></p>

    <h4>We do it for you</h4>
    <p>
      It is a type of action where most of the workload falls on the team of
      DIYinbound and InboundCycle.
    </p>

    <h4>Guided</h4>

    <p>
      It is a type of action where most of the workload falls on your team,
      accompanied by the DIYinbound and InboundCycle team.
    </p>
    `,
  },

  es: {
    recurrent: `
    <p>Las acciones pueden ser <strong>Puntuales</strong> o <strong>Recurrentes</strong>.</p>

    <h4>Acción Puntual</h4>
    
    <p>
      Es un tipo de acción que tiene un principio y un fin: las activas, se ejecutan, las
      documentamos y las damos por terminadas. Luego pasan al archivo por si quieres consultar
      su documentación en el futuro. A menudo, las acciones puntuales tiene sentido contratarlas
      más de una vez, por ejemplo: elaborar diferentes landing pages o elaborar diferentes buyer
      persona.
    </p>

    <h4>Acción Recurrente</h4>
    <p>
      Es un tipo de acción que tiene principio, pero no necesariamente tiene un final, aunque la
      puedes desactivar cuando quieras.
      Suelen ser acciones necesarias para el día día de un proyecto, por ejemplo: la búsqueda de
      palabras clave mensual para poder generar nuevo contenido (acción de inbound SEO), o bien,
      una acción de analítica, en la que mensualmente se analiza un ámbito del proyecto y se
      proponen acciones para el mes siguiente.
    </p>
    `,

    technical: `
    <p>Las acciones pueden ser <strong>Lo hacemos por ti</strong> o <strong>Guiadas</strong></p>
    <h4>Acción Lo hacemos por ti</h4>
    <p>
      Es un tipo de acción donde la mayor parte de la carga de trabajo recae en el equipo de DIYinbound e InboundCycle.
    </p>
    <h4>Acción Guiada</h4>
    <p>
      Es un tipo de acción donde la mayor parte de la carga de trabajo recae en tu equipo, acompañado del equipo de DIYinbound e InboundCycle.
    </p>
    `,
  },
}

export const clientOptions = {
  feedbackFormUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSd19GvwJo8WPJqSWHanag_s12vwbnuiNlCNM4ttrgyXCqtMmQ/viewform',
  helpFormUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSdmZmtaTIGxUbEUnCPo4e2TKkW8WyH999CBO43HCKLA_DdbIg/viewform',
}

// PACKS SETTINGS
export const packsSettings = {
  'no suscription': {
    slots: 0,
    suscription_price: 0,
    weekly_hours: 4,
    icon: () => import('Images/packs/no-suscription.png'),
  },

  'a mi ritmo': {
    slots: 1,
    suscription_price: 400,
    weekly_hours: 4,
    icon: () => import('Images/packs/pricing-bike.png'),
  },

  'es mi prioridad': {
    slots: 3,
    suscription_price: 900,
    weekly_hours: 10,
    icon: () => import('Images/packs/pricing-plane.png'),
  },

  'modo turbo': {
    slots: 5,
    suscription_price: 1400,
    weekly_hours: 20,
    icon: () => import('Images/packs/pricing-rocket.png'),
  },

  suscriptions_url: 'https://diyinbound.com/hojas-de-ruta/a-medida/',
}
// END PACKS SETTINGS
